import { FC } from "react";
import { HorizontalMarquee } from "@tennr/frontend/components/HorizontalMarquee";
import { PartnerCard } from "@tennr/frontend/components/PartnerCard/PartnerCard";

export const PartnersMarquee: FC = () => {
    return(
    <HorizontalMarquee widthMode="full" autoscroll={true} autoscrollSpeed={0.4}>
        <PartnerCard logo="/svg/nma.svg" name="NMA" />
        <PartnerCard logo="/svg/isleep.svg" name="iSLEEP" />
        <PartnerCard logo="/svg/adapthealth.svg" name="AdaptHealth" />
        <PartnerCard logo="/img/customer-logos/flomed-infusion.png" name="Flomed Infusion" />
        <PartnerCard logo="/svg/sleepquest.svg" name="SleepQuest" />
        <PartnerCard logo="/img/customer-logos/thrivewell.png" name="Thrivewell Infusion" />
        <PartnerCard logo="/svg/rothmanortho.svg" name="Rothman Orthopaedics" />
        <PartnerCard logo="/img/customer-logos/simonmed-imaging.png" name="SimonMed Imaging" />
        <PartnerCard logo="/svg/mpowerhealth.svg" name="MPOWERHealth" />
        <PartnerCard logo="/img/customer-logos/reliant-specialty-infusion.png" name="Reliant Specialty Infusion" />
        <PartnerCard logo="/img/customer-logos/total-medical-supply.png" name="Total Medical Supply" />
        <PartnerCard logo="/img/customer-logos/americanhomecare-equipment.png" name="AmericanHomeCare Equipment" />
        <PartnerCard logo="/img/customer-logos/betternight.png" name="BetterNight" />
        <PartnerCard logo="/img/customer-logos/corner-home-medical.png" name="Corner Home Medical" />
        <PartnerCard logo="/img/customer-logos/eastern-medtech.png" name="Eastern Medtech" />
        <PartnerCard logo="/img/customer-logos/norco.png" name="Norco" />
        <PartnerCard logo="/svg/nunns.svg" name="Nunn's" />
        <PartnerCard logo="/img/customer-logos/prism-health-care-services.png" name="Prism Health Care Services" />
        <PartnerCard logo="/img/customer-logos/quality-dme.png" name="Quality DME" />
        <PartnerCard logo="/img/customer-logos/supercarehealth.png" name="SuperCare Health" />
        <PartnerCard logo="/svg/total-sleep-management.svg" name="Total Sleep Management" />
      </HorizontalMarquee>
    )
}
